/**
 * Calcula el Dígito de Verificación (DV) para un NIT en Colombia.
 * @param {string|number} nit El número de identificación.
 * @returns {number} El dígito de verificación calculado.
 */
export function calculateDV(nit) {
    if (!nit) return "";

    const nitStr = nit.toString().replace(/\D/g, "");
    if (nitStr.length === 0) return "";

    const weights = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
    let sum = 0;

    for (let i = 0; i < nitStr.length; i++) {
        const digit = parseInt(nitStr.charAt(nitStr.length - 1 - i), 10);
        sum += digit * weights[i];
    }

    const remainder = sum % 11;
    if (remainder < 2) {
        return String(remainder);
    } else {
        return String(11 - remainder);
    }
}
